module.exports = __webpack_public_path__ + "assets/TranslateSegmentDetailed.e9e2ed3ce746e2ace1c94a1b900e8bf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/TranslateSegmentDetailed.png
// module id = 590
// module chunks = 0